import React from "react";
import UserDetails from "./UserDetails";
import GotoDetailsHeader from "./GotoDetailsHeader";

const UserDetailsDrawerContent = ({
  userData,
  onAssignUser,
  onAssignDepartment,
  onAssignLocation,
  canAssignLocation,
}) => {
  return (
    <>
      <GotoDetailsHeader
        title={userData?.callUserLines?.[0]?.name}
        subtitleLabel="Number"
        subtitle={userData?.callUserLines?.[0]?.number}
        status={userData?.isActive ? "Active" : "Inactive"}
      />

      <div className="mt-8">
        <UserDetails
          userData={userData}
          onAssignUser={onAssignUser}
          onAssignDepartment={onAssignDepartment}
          onAssignLocation={onAssignLocation}
          canAssignLocation={canAssignLocation}
        />
      </div>
    </>
  );
};

export default UserDetailsDrawerContent;
